module.exports = __webpack_public_path__ + "img/huiYuan.6636d135.svg";